import {createSlice} from '@reduxjs/toolkit';
import {WeatherflowUserLink} from '../../api/types';

type Props = {
  link: WeatherflowUserLink | null;
};

export const weatherflowSlice = createSlice({
  name: 'weatherflow',
  initialState: {
    link: null,
  } as Props,
  reducers: {
    setWeatherflowUserLink: (
      state,
      {payload: link}: {payload: WeatherflowUserLink},
    ) => {
      if (state.link === null || link === null) {
        state.link = link;
      } else {
        // mergeDeep in order to keep generic_station key which is not present for station list
        const oldWeatherStations = state.link.account.weather_stations;
        const newWeatherStations = link.account.weather_stations;

        state.link = link;
        const mergedWeatherStations = [];
        newWeatherStations.forEach((newItem) => {
          const oldStation = oldWeatherStations.find(
            (oldItem) => oldItem.device_id === newItem.device_id,
          );
          if (oldStation) {
            mergedWeatherStations.push({...oldStation, ...newItem});
          } else {
            mergedWeatherStations.push(newItem);
          }
        });
        state.link.account.weather_stations = mergedWeatherStations;
      }
    },
  },
});

export const {setWeatherflowUserLink} = weatherflowSlice.actions;

export default weatherflowSlice.reducer;
